import React from 'react';
import { AsyncDashboardBackgroundScript } from '@atlassian/jira-forge-ui-async/src/ui/dashboard-background-script/async.tsx';
import type { ForgeBackgroundScript as ForgeBackgroundScriptType } from '../../types.tsx';

type Props = {
	item: ForgeBackgroundScriptType;
};

export const ForgeBackgroundScript = ({ item }: Props) => (
	<AsyncDashboardBackgroundScript extension={item} extensionData={{}} />
);
